// src/api/profiles.js
import { authFetch, authFetchFormData, TokenManager } from "./interceptors";

const API_BASE_URL = "https://metriciqkontrol.online";
const AUTH_URL = "https://metriciqkontrol.online/auth";

export const profilesService = {
  getMyProfile: async () => {
    try {
      //console.log("👤 Iniciando obtención de perfil...");

      const userData = await authFetch("/api/user/v1/my-profile/", {
        method: "GET",
      });

      // Construir URLs completas para las imágenes
      if (userData.photo_url && !userData.photo_url.startsWith("http")) {
        userData.photo_url = `${API_BASE_URL}${userData.photo_url}`;
      }
      if (
        userData.signature_url &&
        !userData.signature_url.startsWith("http")
      ) {
        userData.signature_url = `${API_BASE_URL}${userData.signature_url}`;
      }

      //console.log("✅ Perfil obtenido exitosamente:", userData);
      return userData;
    } catch (error) {
      //console.error("❌ Error obteniendo perfil:", error);
      throw error;
    }
  },

  changeRoleProfile: async (userId, newRole) => {
    try {
      //console.log("👤 Iniciando cambio de perfil...");

      const updatedProfile = await authFetch(
        `/api/user/v1/profiles/${userId}/`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ role: newRole }),
        },
      );
      //console.log("✅ Perfil actualizado:", updatedProfile);
      return updatedProfile.data;
    } catch (error) {
      //console.error("❌ Error actualizando perfil:", error);
      throw error;
    }
  },

  // 🔥 NUEVO MÉTODO: Cambiar contraseña del usuario actual
  changePassword: async (passwordData) => {
    //console.log("🔐 ===== CAMBIO CONTRASEÑA =====");

    // Validaciones
    if (!passwordData.current_password) {
      throw new Error("La contraseña actual es requerida");
    }
    if (!passwordData.new_password) {
      throw new Error("La nueva contraseña es requerida");
    }
    if (!passwordData.re_new_password) {
      throw new Error("Debes confirmar la nueva contraseña");
    }

    if (passwordData.new_password !== passwordData.re_new_password) {
      throw new Error("Las contraseñas no coinciden");
    }

    const token = localStorage.getItem("authToken");

    //console.log("📤 Enviando petición con current_password");

    // Hacer fetch directo https://metriciqkontrol.online
    const response = await fetch(
    "https://metriciqkontrol.online/auth/users/set_password/",  
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${token}`,
          Accept: "application/json", // 🔥 IMPORTANTE: pedir JSON explícitamente
        },
        body: JSON.stringify({
          current_password: passwordData.current_password,
          new_password: passwordData.new_password,
          re_new_password: passwordData.re_new_password,
        }),
      },
    );
    
    //console.log("Status:", response.status);
    //console.log("Content-Type:", response.headers.get("content-type"));

    // 🔥 MANEJAR DIFERENTES TIPOS DE RESPUESTA
    let data;
    const contentType = response.headers.get("content-type");

    if (contentType && contentType.includes("application/json")) {
      // Respuesta JSON
      data = await response.json();
     //console.log("📦 Respuesta JSON:", data);
    } else {
      // Respuesta texto/HTML
      data = await response.text();
      //console.log("📄 Respuesta texto:", data);
    }

    if (!response.ok) {
      // Manejar errores según el tipo
      if (typeof data === "object") {
        if (data.current_password)
          throw new Error(data.current_password.join(", "));
        if (data.new_password) throw new Error(data.new_password.join(", "));
        if (data.non_field_errors)
          throw new Error(data.non_field_errors.join(", "));
      }
      throw new Error(
        typeof data === "string" ? data : "Error al cambiar contraseña",
      );
    }

    // 🔥 ÉXITO - La contraseña se cambió correctamente
    //console.log("✅ Contraseña cambiada exitosamente");

    // Devolver un objeto de éxito estándar
    return {
      success: true,
      message: "Contraseña cambiada exitosamente",
      data: data,
    };
  },

  // ✅ CORREGIDO: Usar FormData con los nombres correctos que espera Django
  uploadPhoto: async (file) => {
    const formData = new FormData();
    formData.append("photo", file); // Key: 'photo' como espera request.FILES['photo']

   //ocnsole.log("📸 Subiendo foto con FormData...", {
   //   fileName: file.name,
   //   fileType: file.type,
   //   fileSize: file.size,
   //   formDataKeys: Array.from(formData.keys()),
   // });

    try {
      const updatedProfile = await authFetchFormData(
        "/api/user/v1/my-profile/photo/",
        formData,
        "PATCH",
      );

      //console.log("✅ Foto subida exitosamente:", updatedProfile);

      // Construir URL completa para la nueva foto
      if (
        updatedProfile.photo_url &&
        !updatedProfile.photo_url.startsWith("http")
      ) {
        updatedProfile.photo_url = `${API_BASE_URL}${updatedProfile.photo_url}`;
      }

      return updatedProfile;
    } catch (error) {
      //console.error("❌ Error subiendo foto:", error);
      throw new Error(`Error al subir la foto: ${error.message}`);
    }
  },

  // ✅ CORREGIDO: Usar FormData con los nombres correctos que espera Django
  uploadSignature: async (file) => {
    const formData = new FormData();
    formData.append("digital_signature", file); // Key: 'digital_signature' como espera request.FILES['digital_signature']

    //console.log("🖊️ Subiendo firma con FormData...", {
    //  fileName: file.name,
    //  fileType: file.type,
    //  fileSize: file.size,
    //  formDataKeys: Array.from(formData.keys()),
    //});

    try {
      const updatedProfile = await authFetchFormData(
        "/api/user/v1/my-profile/signature/",
        formData,
        "PATCH",
      );

      //console.log("✅ Firma subida exitosamente:", updatedProfile);

      // Construir URL completa para la nueva firma
      if (
        updatedProfile.signature_url &&
        !updatedProfile.signature_url.startsWith("http")
      ) {
        updatedProfile.signature_url = `${API_BASE_URL}${updatedProfile.signature_url}`;
      }

      return updatedProfile;
    } catch (error) {
      //console.error("❌ Error subiendo firma:", error);
      throw new Error(`Error al subir la firma: ${error.message}`);
    }
  },

  // Eliminar foto de perfil
  deletePhoto: async () => {
    //console.log("🗑️ Eliminando foto...");

    try {
      const result = await authFetch("/api/user/v1/my-profile/photo/", {
        method: "DELETE",
      });

      //console.log("✅ Foto eliminada exitosamente");
      return result;
    } catch (error) {
      //console.error("❌ Error eliminando foto:", error);
      throw new Error(`Error eliminando foto: ${error.message}`);
    }
  },

  // Eliminar firma digital
  deleteSignature: async () => {
    //console.log("🗑️ Eliminando firma...");

    try {
      const result = await authFetch("/api/user/v1/my-profile/signature/", {
        method: "DELETE",
      });

      //console.log("✅ Firma eliminada exitosamente");
      return result;
    } catch (error) {
      //console.error("❌ Error eliminando firma:", error);
      throw new Error(`Error eliminando firma: ${error.message}`);
    }
  },
};
